import { NATIVE_TOKEN } from "~/constants/token.constants";
import type { ValueOf } from "~/types/value-of";

export const tokenDetailPageTab = {
  transfers: "transfers",
  holders: "holders",
  "contract-code": "contract-code",
  info: "info",
} as const;
export type tokenDetailPageTab = ValueOf<typeof tokenDetailPageTab>;

export default {
  getTokensPage() {
    return "/tokens";
  },
  getTokensDetailPageWithTab(address: string, tab?: tokenDetailPageTab) {
    if (!tab) {
      if (address === NATIVE_TOKEN.address) tab = tokenDetailPageTab.holders;
      else tab = tokenDetailPageTab.transfers;
    }
    // NXPC는 주소 대신 'nxpc' 식별자 사용 (OR-387)
    const identifier = address === NATIVE_TOKEN.address ? "nxpc" : address;
    return this.getTokensPage() + `/${identifier}/${tab}`;
  },
};
